import ReactDOM from "react-dom/client";
import {createBrowserRouter, RouterProvider} from "react-router-dom";
import {ThemeProvider} from "@material-tailwind/react";

import "./index.css";
import {StyledEngineProvider} from "@mui/material";

const router = createBrowserRouter([
    {
        path: "/",
        lazy: () => import('./App').then(module => ({Component: module.default}))
    },
    {
        path: "/auth/callback",
        lazy: () => import("./infrastructure/Auth/AuthCallback").then(module => ({Component: module.default}))
    },
    {
        path: "/logout",
        lazy: () => import("./infrastructure/Logout").then(module => ({Component: module.Logout}))
    }
])

ReactDOM.createRoot(document.getElementById("root") as HTMLElement).render(
    <StyledEngineProvider injectFirst>
        <ThemeProvider>
            <RouterProvider router={router}/>
        </ThemeProvider>
    </StyledEngineProvider>
);
